<template>
  <div class="fade-in-fwd">
    <div class="container mt-5">
      <h6 class="font-weight-bold">
        {{ $resourceString["myProject.Project.EditPage.Item.EditColorImage"] }}
      </h6>
      <button
        type="button"
        class="wf-modal-button-close btn button-full"
        @click="
          () => {
            hideModal('project-edit-colors-feature-img');
          }
        "
      >
      <span
          class="png-icon png-icon-icons-symbols--k-txtclose"
          aria-label="Close modal"
        />
      </button>

      <div>
        <div class="my-project stepper-container row">
          <ul class="stepper d-flex justify-content-center">
            <li
              v-for="[stepIndex, header] in Object.entries(stepHeaders)"
              :key="header"
              :class="getClassName(stepIndex)"
            >
              {{$resourceString[header] }}
            </li>
          </ul>
        </div>
      </div>

      <div v-if="getContentWizardData.step === 1">
        <step-three />
      </div>

      <div v-if="getContentWizardData.step === 2">
        <step-four />
      </div>
    </div>

    <div class="modal-footer border-0 mx-4">
      <div class="justify-content-between w-100  row">
        <button
          class="btn btn-outline-primary"
          @click="
            () => {
              hideModal('project-edit-colors-feature-img');
            }
          "
        >
          {{ $resourceString["virtualtray.Savetray.Cancel.Button"] }}
        </button>
        <span>
          <button
            v-if="this.getContentWizardData.step == 1"
            class="btn btn-primary"
            :disabled="!this.getContentWizardData.step3.length > 0"
            @click.prevent="handleNext"
          >
          {{ $resourceString["myProject.Project.EditPage.SaveContinue.Button"] }}
          </button>
          <button
            v-if="this.getContentWizardData.step == 2"
            class="btn btn-primary"
            @click.prevent="updateProjectItem"
          >
          {{ $resourceString["myProject.Project.ShareProject.Save.label"] }}
          </button>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getStepHeaders,
  getStepComponent,
  ContentItemTypes,
  isLastStep
} from "../../../../src/stepTree";
import { mapActions, mapGetters } from "vuex";
import stepThree from "../content-wizard-modal/steps/StepThree.vue";
import StepFour from "../content-wizard-modal/steps/StepFour.vue";

export default {
  props: ["projectDetails"],
  data() {
    return {
      partnerProducts: ["Paint"]
    };
  },
  computed: {
    ...mapGetters({
      getContentWizardData: "contentWizard/getContentWizardData",
      getSelectedProduct: "contentWizard/getSelectedProduct"
    }),
    stepHeaders() {
      return getStepHeaders(
        this.getContentWizardData.type.customPattern,
        this.getContentWizardData.isOutsideBoard
      );
    },
    getLastStep() {
      return isLastStep(
        this.getContentWizardData.type.product,
        this.getContentWizardData.step,
        this.getContentWizardData.isOutsideBoard
      );
    }
  },
  components: {
    stepThree,
    StepFour
  },

  methods: {
    ...mapActions({
      setStep: "contentWizard/setStep",
      setStep1: "contentWizard/setStep1",
      updateProductColorImg: "myProject/updateProductColorImg",
      resourceString: "myProject/resourceString",
      resetContent: "contentWizard/resetContent",
      projectAlreadyExistResourceString:
        "myProject/projectAlreadyExistResourceString",
      updateProductFeatureImg: "myProject/updateProductFeatureImg"
    }),

    async reloadPage() {
      window.location.reload();
    },

    async updateProjectItem() {
      let dataStep2 = {
        boardId: this.projectDetails?.boardDetails.id,
        contentItemId: this.getContentWizardData.productItemDetails.id,
        imageLink: this.getContentWizardData.contentItem.coverPhoto,
        imageAltText: this.getContentWizardData.contentItem.coverPhotoImageAltText
      };

      await this.resourceString(
        this.$resourceString["common.accounts.Updated.Msg"]
      );
      await this.projectAlreadyExistResourceString(
        this.$resourceString["common.accounts.DuplicateName.Msg"]
      );

      await this.updateProductFeatureImg(dataStep2).then(resp =>{
        if(resp == true){
          this.hideModal("project-edit-colors-feature-img");
          this.reloadPage();
        }
      });
    },
    getStepComp() {
      if (this.getContentWizardData.step === 1) {
        return null;
      }

      const StepComponent = getStepComponent(
        this.getContentWizardData.type.product,
        4
      );
      return StepComponent;
    },
    getClassName(stepNumber) {
      const num = parseInt(stepNumber, 10);
      return {
        active: this.getContentWizardData.step === num,
        complet: this.getContentWizardData.step > num
      };
    },

    async handleNext() {
      if (this.getContentWizardData.step == 1) {
        let styleImagesToRemoveIds = this.getContentWizardData.productItemDetails.productContentItem.productStyleImages.map(
          image => image.id
        );
        let dataStep1 = {
          boardId: this.projectDetails?.boardDetails.id,
          productId: this.getContentWizardData.productItemDetails
            .productContentItem.id,
          productStyleImages: this.getContentWizardData.step3,
          styleImagesToRemove: styleImagesToRemoveIds,
          styleNumber: this.getContentWizardData.productItemDetails
            .productContentItem.productId
        };
        await this.resourceString(
          this.$resourceString["common.accounts.Updated.Msg"]
        );
        await this.projectAlreadyExistResourceString(
          this.$resourceString["common.accounts.DuplicateName.Msg"]
        );
        await this.updateProductColorImg(dataStep1).then(resp=>{
          if(resp == true){
            this.setStep(this.getContentWizardData.step + 1);
          }
        });
      }
    },
    handleBack() {
      if (
        this.getContentWizardData.step === 2 &&
        this.partnerProducts.includes(
          this.getContentWizardData.contentItem.productType
        )
      ) {
        this.setStep1("brand");
      }
      this.setStep(this.getContentWizardData.step - 1);
      const isCustomPatternType = this.isCustomPattern(
        this.getContentWizardData.contentItem.type
      );
      if (isCustomPatternType) {
        this.setStep1("product");
      }
    },

    hideModal(name) {
      this.$modal.hide(name + "-modal");
      this.resetContent();
      this.reloadPage();
    },
    isCustomPattern(type) {
      ContentItemTypes.customPattern === type;
    },
    beforeDestroy() {
      this.resetContent();
    }
  }
};
</script>
